import axios from 'axios';
import cookies from '../cookies/cookies';
// import { userInfo } from 'os';
import store from '../../store';

let fetch = axios.create({
    timeout: 100 * 1000,
    headers: {
        post: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
    },
});

fetch.interceptors.request.use(
    config => {
        if (cookies.get('userInfo') && cookies.get('userInfo').token) {
            if (config.data == undefined) {
                config.data = {};
            }
            config.data.token = cookies.get('userInfo').token;
        }

        if (config.isUpload) {
            let form = new FormData();
            console.log(config)
            form.append('file', config.data.file);
            if(!config.isThumb){
                form.append('isThumb', false);
            }
            config.headers.post['Content-Type'] = 'multipart/form-data';
            config.data = form;
        }
        return config;
    },
    error => {
        // Do something with request error
        return Promise.reject(error);
    },
);

// Add a response interceptor
fetch.interceptors.response.use(
    response => {
        // Do something with response data
        // console.log(response);
        // console.log(response.data);
        if (response.data && response.data.Type == 'Warning') {
            store.commit('delUserInfo');
        }
        return response.data;
        // if (response.data) {
        //     return response.data;
        // } else {
        //     return response;
        // }
    },
    error => {
        // Do something with response error
        // console.log(eroor);
        return Promise.reject(error);
    },
);

export default fetch;
